import { Row } from '../../../Cart/components/Row';
import { Cart } from '../../../Cart/Cart';
import { Divider } from '../../../components/Divider';
import { DividedPage } from '../../../components/DividedPage';

export type RefundAmountsProps = React.HTMLAttributes<HTMLDivElement> & {
	total: number;
	payments: JSX.Element[];
};

export const RefundAmounts: React.FC<RefundAmountsProps> = ({
	total,
	payments
}) => {
	return (
		<div className="refund-amounts">
			<Cart>
				<Row>
					<h3 className="font-weight-heavy text-primary">
						Amount Refunded
					</h3>

					<h3 className="mb-0">${(total / 100).toFixed(2)}</h3>
				</Row>
			</Cart>
			<hr className="divider mt-3 mb-3 border-light-gray" />
			<div className="order-payments pt-3">
				<h4 className="text-secondary mb-0">
					Refunded Payment{payments.length > 1 ? 's' : ''}
				</h4>

				<Divider my={3} />

				<DividedPage dividerProps={{ my: 2, borderColor: 'light' }}>
					{payments}
				</DividedPage>
			</div>
		</div>
	);
};
